import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=9940b2ee&scoped=true&"
import script from "./Publisher.vue?vue&type=script&lang=js&"
export * from "./Publisher.vue?vue&type=script&lang=js&"
import style0 from "./Publisher.vue?vue&type=style&index=0&id=9940b2ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9940b2ee",
  null
  
)

export default component.exports